export enum ItemType {
  Export = "Export",
  Reimport = "Reimport",
  Makro = "Makro",
  CategoryExport = "CategoryExport",
  Datenvalidierung = "Datenvalidierung",
  Workflow = "Workflow",
}
